import { format as formatDate } from '../utils/date';
/**
 * 控件支持的模型绑定的数据类型
 */

export const DATA_TYPES = {
  string: {
    value: 'String',
    label: '字符串'
  },
  number: {
    value: 'Number',
    label: '数字'
  },
  boolean: {
    value: 'Boolean',
    label: '布尔值'
  },
  date: {
    value: 'Date',
    label: '日期/时间'
  },
  array: {
    value: 'Array',
    label: '列表'
  }
};
const parser = {
  [DATA_TYPES.string.value](value, format = 'yyyy-MM-dd') {
    if (value === null || value === undefined) {
      return '';
    }

    if (value instanceof Date) {
      return formatDate(value, format);
    }

    return '' + value;
  },

  [DATA_TYPES.number.value](value) {
    if (value === '' || isNaN(value)) {
      return '';
    }

    return +value;
  },

  [DATA_TYPES.boolean.value](value) {
    return Boolean(value);
  },

  [DATA_TYPES.date.value](value) {
    if (!value) {
      return null;
    }

    return value;
  },

  [DATA_TYPES.array.value](value) {
    return value;
  }

};
/**
 * 使用指定数据类型进行数据转换
 */

export const formatValue = (value, dataType, format) => {
  const dataParser = parser[dataType];

  if (!dataParser) {
    return value;
  }

  return dataParser(value, format);
};